/**
 * Copyright 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useEstateFetch, useTabsWithUrl } from "~/hooks";
import { isCloudResource } from "~/tools";
import {
  disabledFilterFields,
  DisabledFilters,
} from "~/views/estate/components/EstateFilters";
import { Ec2RelatedResourcesTab, EstateTabsData } from "../components";

type Props = {
  data: EstateTabsData;
};

export function Ec2SecurityGroupTabs({ data }: Props) {
  const { activeTab, setActiveTab } = useTabsWithUrl();

  const resourceName =
    data.estateRecord && isCloudResource(data.estateRecord)
      ? data.estateRecord.name
      : "";

  const { result: dataEstate, ...filters } = useEstateFetch({
    defaultFilters: {
      typeSubtype: ["ec2/instance"],
      securityGroup: [resourceName],
    },
    skipFields: disabledFilterFields.get(DisabledFilters.APPS),
    activeTab,
  });

  return (
    <Ec2RelatedResourcesTab
      data={data}
      dataEstate={dataEstate}
      estateFilters={filters}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
    />
  );
}
